<template>
  <article>
    <section class="xbed-sub-title">
      <span>房型详情</span>
    </section>

    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
      <TabPane label="基本信息" name="baseInfo" ref="baseInfo">
        <section>
          <Row>
            <Col span="3" class-name="text-align-right">xbed门店ID</Col>
            <Col span="8" offset="1">{{baseInfo.channelRoomType.xbedHotelId}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">门店名称</Col>
            <Col span="8" offset="1">{{baseInfo.channelRoomType.xbedHotelName}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">房型id</Col>
            <Col span="8" offset="1">{{baseInfo.channelRoomType.roomTypeId}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">销售状态</Col>
            <Col span="3" offset="1" v-show="!baseInfo.showEditBaseInfoStatus">{{baseInfo.channelRoomType.status=="S01"?"上架":"下架"}}</Col>
            <Col span="3" offset="1" v-show="baseInfo.showEditBaseInfoStatus">
              <Select size="small" v-model="baseInfo.editedSaleStatus" filterable>
                <Option value="S01">上架</Option>
                <Option value="S02">下架</Option>
              </Select>
            </Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">房型名称</Col>
            <Col span="8" offset="1" v-show="!baseInfo.showEditBaseInfoStatus">{{baseInfo.channelRoomType.name}}</Col>
            <Col span="8" offset="1" v-show="baseInfo.showEditBaseInfoStatus">
              <Input type="text" :maxlength="36" ref="newRoomTypeName" :value="baseInfo.channelRoomType.name">
                <span slot="append"> {{editingRoomTypeName}} / 36</span>
              </Input>
            </Col>
          </Row>
          <br>
          <Row>
            <Col span="2" offset="4">
              <Button type="primary" :loading="baseInfo.editBaseInfoLoading" @click="changeBasicInfoStatus">{{!baseInfo.showEditBaseInfoStatus?"编辑":"保存"}}</Button>
            </Col>
          </Row>
        </section>
        <br>
        <section>
          <Row type="flex" align="middle">
            <Col span="8" class-name="text-align-right"><h1>打包信息</h1></Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">信息房ID</Col>
            <Col span="8" offset="1">{{baseInfo.packageInfo.unifyInfoRoomId}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">信息房名称</Col>
            <Col span="8" offset="1">{{baseInfo.packageInfo.unifyInfoRoom}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">取价房ID</Col>
            <Col span="8" offset="1">{{baseInfo.packageInfo.unifyPriceRoomId}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">取价房名称</Col>
            <Col span="8" offset="1">{{baseInfo.packageInfo.unifyPriceRoom}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">打包房数</Col>
            <Col span="8" offset="1">{{baseInfo.packageInfo.packageCount}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">有效房数</Col>
            <Col span="8" offset="1">{{baseInfo.packageInfo.validCount}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">本日可用房量</Col>
            <Col span="8" offset="1">{{baseInfo.packageInfo.availableCount}}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">缓冲房量</Col>
            <Col span="3" offset="1">
              <span v-if="!editRoomBuffer">{{baseInfo.packageInfo.bufferNum}}</span>
              <Input v-if="editRoomBuffer" type="number" v-model="inputRoomBuffer"></Input>
            </Col>
            <Col span="3" offset="1">
              <Button type="primary" @click="doModifyRoomBufferFn">
                {{editRoomBuffer?'保存':'编辑'}}
              </Button>
            </Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">本日渠道剩余可用房量</Col>
            <Col span="8" offset="1">{{baseInfo.packageInfo.remainCount}}</Col>
          </Row>
        </section>
      </TabPane>
      <TabPane label="打包房间列表" name="pkgRoomList" ref="pkgRoomList">
        <Form  @submit.native.prevent="preventSubmit" :model="pkgRoomForm" inline>
          <FormItem prop="name" label="楼宇ID：" :label-width="80">
            <Input type="text" v-model="pkgRoomForm.buildingId" placeholder="查询楼宇ID"></Input>
          </FormItem>
          <FormItem prop="name" label="房间名称：" :label-width="80">
            <Input type="text" v-model="pkgRoomForm.name" placeholder="查询房间名称"></Input>
          </FormItem>
          <FormItem prop="name" label="房号：" :label-width="60">
            <Input type="text" v-model="pkgRoomForm.roomNo" placeholder="查询房号"></Input>
          </FormItem>
          <FormItem prop="pkgRoomQuery">
            <Button type="primary" @click="queryWithKeyword">查询</Button>
          </FormItem>
          <FormItem prop="addPkgRoom">
            <Button @click="queryUnbindRoomList" type="primary">新增打包</Button>
          </FormItem>
        </Form>
        <Table stripe :loading="pkgRoomList.loading" height="450" :columns="pkgRoomColumns" :data="pkgRoomList.data"></Table>
        <div style="float: left;margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :total="pkgRoomList.count" :current="pkgRoomList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </TabPane>
    </Tabs>

    <Modal v-model="modalDisplay" ref="addPkgModal" :loading="modalLoading" :width="1100" title="未打包房间列表" @on-ok="prepareAddPkgRoomType" @on-cancel="cancelAddPkgRoomType" ok-text="确定打包" cancel-text="取消">
      <Form :model="modalForm" @submit.native.prevent="preventSubmit" inline>
        <FormItem  label="查询：" prop="modalKeyWord" :label-width="50">
          <Input type="text" v-model="modalForm.keyword" placeholder="查询关键字"></Input>
        </FormItem>
        <FormItem prop="modalQuery">
          <Button type="primary" @click="queryModalDataWithKeyword">查询</Button>
        </FormItem>
        <FormItem prop="modalAllSelect">
          <Button type="primary" @click="selectedAll">全选</Button>
        </FormItem>
        <FormItem prop="modalAntiSelect">
          <Button type="primary" @click="antiSelected">反选</Button>
        </FormItem>
      </Form>
      <Table stripe ref="modalSelection" :loading="modalBundle.loading" @on-selection-change="selectedChangeWithRow" :columns="modalColumns" :data="modalDisplayData"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="modalBundle.count" :current="modalBundle.page" @on-page-size-change="changeModalPageSize" @on-change="changeModalPage"></Page>
      </div>
      <Row>
        <Col>{{`共${filterModalDataList.length}房，已选择${modalSelectedRoomType.size}房`}}</Col>
      </Row>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.roomTypeId = Utils.getUrlParameterByName("roomTypeId");

    this.apiHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), //走阿里云需要
      'Authorization': Utils.findFromLocalStorage("Author-token"),//走阿里云需要
      // 'group': 'dev',
      // 'secret': 'c98606c16859082e3c80a2ae2493207b' // 开发环境直接走ip请求才需要加该参数
    }
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.toggleTab(this.currTabName);
  },
  computed: {
    editingRoomTypeName: function() {
      let nameLength = 0;
      if (this.baseInfo.showEditBaseInfoStatus) {
        nameLength = this.$refs.newRoomTypeName.currentValue.length;
      }
      return nameLength; 
    }
  },
  data() {
    return {
      currTabName: "baseInfo",
      baseInfo: {
        channelRoomType: {
          xbedHotelId: "",
          xbedHotelName: "",
          roomTypeId: "",
          status: "",
          name: "",
        },
        packageInfo: {
          unifyInfoRoomId: "",
          unifyInfoRoom: "",
          unifyPriceRoomId: "",
          unifyPriceRoom: "",
          packageCount: "",
          validCount: "",
          availableCount: "",
          bufferCount: "",
          remainCount: ""
        },
        showEditBaseInfoStatus: false,
        editBaseInfoLoading: false,
        editedSaleStatus: "S01",
      },
      editRoomBuffer: false,
      inputRoomBuffer: '',
      pkgRoomList: {
        count: 0,
        pageCount: 0,
        page: 1,
        pageSize: 10,
        loading: false,
        data: []
      },
      pkgRoomColumns: [
        {
          title: "楼宇ID",
          key: "buildingId",
          align: "center",
          width: 90
        },
        {
          title: "楼层",
          key: "roomFloor",
          align: "center",
          width: 100
        },
        {
          title: "房间ID",
          key: "roomId",
          align: "center",
          width: 100
        },
        {
          title: "房间名称",
          key: "custRoomName",
          align: "center",
          width: 300
        },
        {
          title: "房号",
          key: "custRoomNo",
          align: "center",
          width: 100
        },
        {
          title: "房型",
          key: "houseType",
          align: "center",
          width: 150
        },
        {
          title: "床数",
          key: "bedCount",
          align: "center",
          width: 100
        },
        {
          title: "销售状态",
          key: "status",
          align: "center",
          width: 100,
          render: (h, params) => {
            let status = "";
            switch(params.row.status) {
              case "S01":
              status = "上架";
              break;
              case "S02":
              status = "下架";
              break;
            }
            return h("div", {}, status);
          }
        },
        {
          title: "信息房",
          key: "infoRoom",
          align: "center",
          width: 150,
          render: (h, params) => {
            let status = params.row.isUnifyInfo == "N" ? "取信息" : "信息房";
            let element = params.row.isUnifyInfo == "N" ? "Button" : "div";
            let btnOption = {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        render: modalH => {
                          let modalText = `确定将此房间的信息详情设为房型信息？`;
                          return modalH("div", {
                            style: {
                              fontSize: "16px",
                            },
                          }, modalText)
                        },
                        onOk: () => {
                          this.activeRoomInfo(params.index);
                        }
                      })
                    }
                  }
                }
            let option = params.row.isUnifyInfo == "Y" ? {} : btnOption;
            return h(element, option, status);
          }
        },
        {
          title: "是否取价",
          key: "isPrice",
          align: "center",
          width: 150,
          render: (h, params) => {
            let status = params.row.isUnifyPrice == "N" ? "取价" : "取价房";
            let element = params.row.isUnifyPrice == "N" ? "Button" : "div";
            let btnOption = {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        render: modalH => {
                          let modalText = `确定将此房间的价格设为房型标准价？`;
                          return modalH("div", {
                            style: {
                              fontSize: "16px",
                            },
                          }, modalText)
                        },
                        onOk: () => {
                          this.activeRoomPrice(params.index);
                        }
                      })
                    }
                  }
                }
            let option = params.row.isUnifyPrice == "Y" ? {} : btnOption;
            return h(element, option, status);
          }
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      if (params.row.isUnifyInfo=="Y"||params.row.isUnifyPrice=="Y") {
                        this.$Notice.error({
                          title: "删除打包失败",
                          desc: "房间为信息房或取价房，不可删除打包！"
                        });
                        return;
                      }
                      this.$Modal.confirm({
                        render: modalH => {
                          let modalText = `确定取消打包此房间？该房间将恢复独立销售`;
                          return modalH("div", {
                            style: {
                              fontSize: "16px",
                            },
                          }, modalText)
                        },
                        onOk: () => {
                          // TODO: 删除打包
                          this.removeRoomToRoomType(params.index);
                        }
                      })
                    }
                  }
                },
                "删除打包"
              )
            ]);
          }
        }
      ],
      pkgRoomForm: {
        buildingId: "",
        name: "",
        roomNo: ""
      },
      modalDisplay: false,
      modalLoading: true,
      modalForm: {
        keyword: "",
      },
      modalColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: "楼宇ID",
          key: "buildingId",
          align: "center",
          width: 90
        },
        {
          title: "楼层",
          key: "roomFloor",
          align: "center",
          width: 80
        },
        {
          title: "房间ID",
          key: "roomId",
          align: "center",
          width: 84
        },
        {
          title: "房间名称",
          key: "custRoomName",
          align: "center",
          width: 150
        },
        {
          title: "房号",
          key: "custRoomNo",
          align: "center",
          width: 150
        },
        {
          title: "房型",
          key: "roomTypeName",
          align: "center",
          width: 100
        },
        {
          title: "床数",
          key: "bedCount",
          align: "center",
          width: 84
        },
        {
          title: "面积",
          key: "area",
          align: "center",
          width: 84
        },
        {
          title: "销售状态",
          key: "flag",
          align: "center",
          width: 100
        },
        {
          title: "租赁类型",
          key: "tagCode",
          align: "center",
          width: 100
        }
      ],
      modalBundle: {
        name: "room",
        tabName: "房间列表",
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      },
      modalListKey: {
        flag: {
          1: "销售中",
          2: "删除",
          3: "下架",
          4: "筹建中",
          5: "售前展示"
        },
        tagCode: {
          "2001": "短租",
          "2002": "长租",
        }
      },
      modalDisplayData: [],
      filterModalDataList: [],
      modalSelectedRoomType: new Set()
    };
  },
  methods: {
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.queryRoomTypeData();
    },
    async queryRoomTypeData() {
      if (this.currTabName == "baseInfo") {
        this.queryBaseInfo();
      } else if (this.currTabName == "pkgRoomList") {
        this.queryRoomTypeList();
      }
    },
    async queryBaseInfo() {
      let resp = (await this.queryRoomTypeInfo(
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      Object.assign(this.baseInfo, resp);
      this.baseInfo.editedSaleStatus = resp.channelRoomType.status;
      this.requestRoomtypeBufferNum()
    },
    queryRoomTypeInfo(token, env) {
      return API.omsAPI[env].ota.queryRoomTypeInfo(
        this.roomTypeId,
        token
      );
    },
    async queryRoomTypeList() {
      this.pkgRoomList.loading = true;
      const resp = (await this.queryRoomList(
        this.pkgRoomList,
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      this.pkgRoomList.data = resp.list;
      this.pkgRoomList.page = resp.page;
      // this.pkgRoomList.pageSize = resp.rows;
      this.pkgRoomList.pageCount = resp.pageCount;
      this.pkgRoomList.count = resp.rowCount;
      this.pkgRoomList.loading = false;
    },
    queryRoomList(roomList, token, env) {
      let buildingId = this.pkgRoomForm.buildingId ? this.pkgRoomForm.buildingId : null;
      let roomNo = this.pkgRoomForm.roomNo ? this.pkgRoomForm.roomNo : null;
      return API.omsAPI[env].ota.queryRoomList(
        buildingId,
        roomList.page,
        this.pkgRoomForm.name,
        roomNo,
        this.roomTypeId,
        roomList.pageSize,
        token
      );
    },
    queryWithKeyword(){
      this.pkgRoomList.page = 1;
      this.queryRoomTypeData();
    },
    changePage(pageIndex) {
      this.pkgRoomList.page = pageIndex;
      this.queryRoomTypeList();
    },
    changePageSize(pageSize) {
      this.pkgRoomList.page = 1;
      this.pkgRoomList.pageSize = pageSize;
      this.queryRoomTypeList();
    },
    async changeBasicInfoStatus() {
      if (this.baseInfo.showEditBaseInfoStatus) {
        if (this.$refs.newRoomTypeName.currentValue.length == 0) {
          this.$Notice.error({
            title: "保存失败",
            desc: "房型名称不能为空"
          });
          return;
        }
        this.baseInfo.editBaseInfoLoading = true;
        let resp = (await API.omsAPI[this.env].ota.updateRoomType(
          this.$refs.newRoomTypeName.currentValue,
          this.username,
          this.roomTypeId,
          this.baseInfo.editedSaleStatus,
          this.token
        )).data;
        if (resp.retCode) {
          // 错误警告
          this.$Notice.error({
            title: "保存失败",
            desc: resp.msg
          });
          this.$refs.newRoomTypeName.currentValue = this.baseInfo.channelRoomType.name;
          this.baseInfo.editedSaleStatus = this.baseInfo.channelRoomType.status;
        } else {
          this.$Notice.success({
            title: "保存成功"
          });
          this.baseInfo.channelRoomType.name = this.$refs.newRoomTypeName.currentValue;
          this.baseInfo.channelRoomType.status = this.baseInfo.editedSaleStatus;
        }
      }
      this.baseInfo.editBaseInfoLoading = false;
      this.baseInfo.showEditBaseInfoStatus=!this.baseInfo.showEditBaseInfoStatus;
    },
    changeModalPage(pageIndex) {
      this.modalBundle.page = pageIndex;
      this.displayUnbindRoomList();

      this.$nextTick(function () {
        this.selectedChange();
      })
    },
    changeModalPageSize(pageSize) {
      this.modalBundle.page = 1;
      this.modalBundle.pageSize = pageSize;
      this.displayUnbindRoomList();

      this.$nextTick(function () {
        this.selectedChange();
      })
    },
    // 取信息
    async activeRoomInfo(index) {
      let roomType = this.pkgRoomList.data[index];

      let resp = (await API.omsAPI[this.env].ota.activeRoomInfo(
        roomType.roomId,
        this.roomTypeId,
        this.username,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "取信息失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "取信息成功"
        });

        this.pkgRoomList.page = 1;
        this.queryRoomTypeList();
      }
    },
    // 取价房
    async activeRoomPrice(index) {
      let roomType = this.pkgRoomList.data[index];

      let resp = (await API.omsAPI[this.env].ota.activeRoomPrice(
        roomType.roomId,
        this.roomTypeId,
        this.username,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "取价失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "取价成功"
        });

        this.pkgRoomList.page = 1;
        this.queryRoomTypeList();
      }
    },
    // 查询未打包房间列表
    async queryUnbindRoomList() {
      this.modalDisplay = true;
      this.modalBundle.loading = true;
      let resp = (await this.queryRoomTypeModalListWithUnbind(this.roomTypeId, this.token, this.env)).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.roomList.forEach(room => {
        room.tagCode = room.tagCode.split(',').length == 2 ? "长租，短租" : this.modalListKey.tagCode[room.tagCode] || "";
        room.flag = this.modalListKey.flag[room.flag] || "";
      })
      this.modalBundle.data = resp.roomList;
      this.modalBundle.count = resp.roomList.length;
      this.modalBundle.pageCount = (this.modalBundle.count % this.modalBundle.page) == 0 ? (this.modalBundle.count / this.modalBundle.page) : (this.modalBundle.count / this.modalBundle.page + 1)
      this.filterModalDataList = this.modalBundle.data;
      this.displayUnbindRoomList();
      this.modalBundle.loading = false;
    },
    queryRoomTypeModalListWithUnbind(roomTypeId, token, env) {
      return API.omsAPI[env].ota.queryUnbindRoomList(
        roomTypeId,
        token
      )
    },
    // 展示当前页数的未打包房间
    displayUnbindRoomList() {
      let startIndex = (this.modalBundle.page-1) * this.modalBundle.pageSize;
      let endIndex = this.modalBundle.pageSize * this.modalBundle.page;
      this.modalDisplayData = [];
      if (this.modalBundle.count<=5) {
        this.modalDisplayData = this.filterModalDataList
      } else {
        let filterModalDataList = [];
        for (let i=startIndex; i<endIndex; i++) {
          if (!this.filterModalDataList[i]) break;
          filterModalDataList.push(this.filterModalDataList[i]);
        }
        this.modalDisplayData = filterModalDataList;
      }
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
    // 前端查询
    queryModalDataWithKeyword() {
      this.modalBundle.loading = true;
      this.filterModalDataList = this.filterModalDataWithKeyword();
      this.modalBundle.page = 1;
      this.modalBundle.count = this.filterModalDataList.length;
      this.modalBundle.pageCount = (this.modalBundle.count % this.filterModalDataList.length) == 0 ? (this.modalBundle.count / this.filterModalDataList.length) : (this.modalBundle.count / this.filterModalDataList.length + 1)
      this.displayUnbindRoomList();
      this.modalBundle.loading = false;

      this.$nextTick(() => {
        this.selectedChange();
      })
    },
    // 前端筛选
    filterModalDataWithKeyword() {
      let self = this;
      return this.modalBundle.data.filter(function (room){
        let result = false;
        for (let itemKey in room) {
          if (self.skipKeyFromData(itemKey)) {
            continue;
          }
          let queryItem = '' + room[itemKey];
          if (queryItem.toUpperCase().indexOf((self.modalForm.keyword).toUpperCase()) !== -1) {
            result = true;
            break;
          }
        }
        return result;
      });
    },
    skipKeyFromData(key) {
      let isSkip = false;
      switch(key) {
        case 'businessTime':
        case 'bedDescribe':
        case 'createDate':
        case 'custRoomAddr':
        case 'defaultPrice':
        case 'district':
        case 'modiDate':
        case 'sort':
          isSkip = true;
          break;
      }
      return isSkip;
    },
    async prepareAddPkgRoomType() {
      if (this.modalSelectedRoomType.size == 0) {
        this.$Notice.error({
          title: "新增打包失败",
          desc: "未选择房型"
        });
        this.$refs.addPkgModal.buttonLoading = false;
        return;
      }
      // TODO: 新增房型
      let roomIds = Array.from(this.modalSelectedRoomType).toString()
      let resp = (await this.addRoomsToRoomType(this.username, roomIds, this.roomTypeId, this.token, this.env)).data;
      if (resp.retCode) {
        // 错误警告
        this.$refs.addPkgModal.buttonLoading = false;
        this.$Notice.error({
          title: "新增打包失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "新增打包成功"
        });
        this.modalDisplay = false;
        this.refreshTable();
        this.resetAddModalData();
      }
    },
    cancelAddPkgRoomType() {
      this.resetAddModalData();
    },
    addRoomsToRoomType(username, roomIds, roomTypeId, token, env) {
      return API.omsAPI[env].ota.addRoomsToRoomType(
        username,
        roomIds,
        roomTypeId,
        token
      )
    },
    async removeRoomToRoomType(index) {
      let room = this.pkgRoomList.data[index];

      let resp = (await API.omsAPI[this.env].ota.removeRoomToRoomType(
        room.roomId,
        this.roomTypeId,
        this.username,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除打包失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除打包成功"
        });
        this.pkgRoomList.data.splice(index, 1);
        this.queryRoomTypeList()
      }
    },
    // 单行选择
    selectedChangeWithRow() {
      let length = Object.keys(this.$refs.modalSelection.objData).length;
      for (let i=0; i<length; i++) {
        let roomId = this.$refs.modalSelection.objData[i].roomId;
        let isChecked = this.$refs.modalSelection.objData[i]._isChecked;
        if (!isChecked&&this.modalSelectedRoomType.has(roomId)) {
          this.modalSelectedRoomType.delete(roomId);
        } else if (isChecked&&!this.modalSelectedRoomType.has(roomId)) {
          this.modalSelectedRoomType.add(roomId);
        }
      }
      this.updateModalSelectedRoomType();
    },
    // 选择全部
    selectedAll() {
      for (let i=0; i<this.filterModalDataList.length; i++) {
        this.modalSelectedRoomType.add(this.filterModalDataList[i].roomId);
      }
      this.selectedChange();
    },
    // 反选
    antiSelected() {
      for (let i=0; i<this.filterModalDataList.length; i++) {
        let roomId = this.filterModalDataList[i].roomId;
        if (this.modalSelectedRoomType.has(roomId)) {
          this.modalSelectedRoomType.delete(roomId);
        } else {
          this.modalSelectedRoomType.add(roomId);
        }
      }
      this.selectedChange();
    },
    // 选择后样式变化
    selectedChange() {
      let length = Object.keys(this.$refs.modalSelection.objData).length;
      for (let i=0; i<length; i++) {
        let roomId = this.$refs.modalSelection.objData[i].roomId;
        if (this.modalSelectedRoomType.has(roomId)) {
          this.$refs.modalSelection.objData[i]._isChecked = true;
        } else {
          this.$refs.modalSelection.objData[i]._isChecked = false;
        }
      }
      this.updateModalSelectedRoomType();
    },
    // 更新选择未打包房间的数据
    updateModalSelectedRoomType() {
      this.modalSelectedRoomType = new Set(this.modalSelectedRoomType);
    },
    resetPkgRoomList() {
      this.pkgRoomList = {
        count: 0,
        pageCount: 0,
        page: 1,
        pageSize: 10,
        loading: false,
        data: []
      }
    },
    resetAddModalData() {
      this.modalBundle = {
        name: "room",
        tabName: "房间列表",
        type: 1,
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      }
      this.modalSelectedRoomType = new Set();
      this.modalForm = {
        keyword: "",
      };
    },
    refreshTable() {
      this.resetPkgRoomList();
      this.queryRoomTypeList();
    },
    doModifyRoomBufferFn() {
      if (!Utils.hasPermission('oms_ota_dailyInventory_updateBufferCount')) {
        this.$Notice.error({
          title: '无权限操作'
        })
        return
      }
      if (this.editRoomBuffer) {
        if (this.inputRoomBuffer!=null && this.inputRoomBuffer.trim()!= '') {
          if (this.inputRoomBuffer > this.baseInfo.packageInfo.packageCount) {
            this.$Notice.error({
              title: '缓冲房量不能大于打包房数'
            })
            return
          }
        } else {
          this.$Notice.error({
            title: '请输入缓冲房量'
          })
          return
        }
        this.requestModifyRoomBufferFn()
      } else {
        this.editRoomBuffer = !this.editRoomBuffer
      }
    },
    async requestModifyRoomBufferFn () {
      let params = {
        roomTypeId: this.baseInfo.channelRoomType.roomTypeId,
        hotelId: this.baseInfo.channelRoomType.xbedHotelId,
        bufferNum: this.inputRoomBuffer,
        operater: this.username
      }
      let resp = (await API.omsAPI[this.env].clientServer.modifyRoomtypeBuffer(params, this.apiHeaders)).data
      if (resp.retCode) {
        this.$Notice.error({
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "保存成功",
        });
        this.inputRoomBuffer = ''
        this.requestRoomtypeBufferNum()
      }
      this.editRoomBuffer = !this.editRoomBuffer
    },
    async requestRoomtypeBufferNum () {
      let params = {
        roomTypeId: this.baseInfo.channelRoomType.roomTypeId,
      }
      let resp = (await API.omsAPI[this.env].clientServer.getRoomtypeBuffer(params, this.apiHeaders)).data
      if (resp.retCode) {
        this.$Notice.error({
          desc: resp.msg
        });
      } else {
        this.baseInfo.packageInfo = Object.assign({}, this.baseInfo.packageInfo, {
          bufferNum: resp.bufferNum
        })
        this.inputRoomBuffer = (resp.bufferNum).toString()
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ota/roomtype-detail.vue